export default __webpack_public_path__ + "static/media/socialmedia.960d08ed.webp";